import { getShareFrom, isTGPlatformByBuildType, isProductTypeApp } from '@/utils'
import { queryURLParams } from 'web-utils/url'

export const env = import.meta.env.MODE
export const productType = import.meta.env.VITE_PRODUCT_TYPE
export const isMaster =
  productType === 'master' || productType === 'gold130' || productType === 'master130'
export const isBolly = productType === 'bolly'

export const isReferralEarnApp = import.meta.env.VITE_APP_TYPE === 'referralEarn'
export const isWaRecallApp = import.meta.env.VITE_APP_TYPE === 'waRecall'
export const isAgentGrowthApp = import.meta.env.VITE_APP_TYPE === 'agentGrowth'

const isProductApp = isProductTypeApp()
export const appType = import.meta.env.VITE_APP_TYPE
export const isTaurusGo = appType === 'go'
export const isOnlineEarning = appType === 'earn'
export const isMakeMoney = appType === 'make'
export const isMakeMoneySEO = appType === 'mmseo'
export const uuIdKey = isProductApp ? `u_i_d_${appType}_${productType}` : `u_i_d_${appType}`
export const codeKey = `c_${appType}`
export const tokenKey = 'token'
export const isLoginKey = `i_l_k_${appType}`
export const offlineDialogKey = `off_dia_fl_${appType}`
export const isFirstComeKey = `is_fir_c_${appType}`
export const fromKey = `_f_${appType}`
export const paramAKey = `_a_f_${appType}`
export const devVisitedKey = 'ab_v_k'
export const wheelDrawKey = 'LuckyDrawLite'
export const cpDefaultCode = '5hfusxq'
export const master36Channel = 'slm_1500036'
export const referralEarnGrabTaskFaildKey = 'gb_tk_fa'
export const master36Pkg = 'com.palacezone.teenpattimaster'
export const master36Url =
  'https://d1c156kgtsniy2.cloudfront.net/cg/trs/ipnk5c5r0hmc5udztwg9wq4/{code}/TeenPattiMaster-36.apk?ext={ext}'
export const master30 =
  'https://d1nljmzysjivuc.cloudfront.net/cg/trs/9pnk5c5r0hmc5udztwg9wpy/{code}/TeenPattiMaster-30.apk'
export const master130 =
  'https://d1tmcziyb9z23q.cloudfront.net/cg/trs/ppnk5c5r0hmc5udztwga4fq/{code}/TeenPattiMaster-130.apk'
export const gold30 =
  'https://dkhnwx4ck77rc.cloudfront.net/cg/trs/spnk5c5r0hmbpflrqf6d8fa/{code}/TeenPattiGold-30.apk'
export const gold130 =
  'https://d1s98y9u6agiz4.cloudfront.net/cg/trs/hpnk5c5r0hmbpflrqf6dg52/{code}/TeenPattiGold-130.apk'
export const canInstallKey = `c_in_k_${appType}`
export const ONLINE_EARNING_VERSION = '224100'
export const TAURUS_GO_VERSION = '225100'
export const MAKE_MONEY_VERSION = '226100'
export const MAKE_MONEY_SEO_VERSION = '227100'
export const TG_APP_TYPE = import.meta.env.VITE_TG_TYPE
// referralEarn 新手任务奖励
export const NEWBIE_TASK_TOTAL_REWARD = 21
// 新手流程弹窗标识，h5和tg端闭关弹窗后记录，用于首页banner显示
export const NEWBIE_TASK_POPUP = 'nb_task_pop'

const hasSLCache = !!sessionStorage.getItem('i_s_l')
export const isFromShortLink = hasSLCache || queryURLParams('sf') === 'SHORT_LINK'
if (!hasSLCache && isFromShortLink) {
  sessionStorage.setItem('i_s_l', '1')
}

const tgChannelConfigTest = {
  master: {
    bot: `https://t.me/private_domain_test_bot_bot?start={code}-{webUuid}`,
    channelId: '-1003724622303'
  },
  bolly: {
    bot: `https://t.me/private_domain_test2_bot_bot?start={code}-{webUuid}`,
    channelId: '-1003714444311'
  },
  gold130: {
    bot: `https://t.me/private_domain_testgold1300_bot?start={code}-{webUuid}`,
    channelId: '-1003904419028'
  },
  master130: {
    bot: `https://t.me/private_domain_test_bot_bot?start={code}-{webUuid}`,
    channelId: '-1003724622303'
  }
}
const tgChannelConfigPre = {
  master: {
    bot: `https://t.me/private_domain_pre1_bot_bot?start={code}-{webUuid}`,
    channelId: '-1003820260897'
  },
  bolly: {
    bot: `https://t.me/private_domain_pre2_bot_bot?start={code}-{webUuid}`,
    channelId: '-1003828887289'
  },
  gold130: {
    bot: `https://t.me/private_domain_pregold1300_bot?start={code}-{webUuid}`,
    channelId: '-1003869227241'
  },
  master130: {
    bot: `https://t.me/private_domain_pre1_bot_bot?start={code}-{webUuid}`,
    channelId: '-1003820260897'
  }
}
const tgChannelConfigPro = {
  master: {
    bot: `https://t.me/tp_club_arena_bot?start={code}-{webUuid}`,
    channelId: '-1003704807614'
  },
  bolly: {
    bot: `https://t.me/bolly_playzone_bot?start={code}-{webUuid}`,
    channelId: '-1003897810688'
  },
  gold130: {
    bot: `https://t.me/funzone_hub_bot?start={code}-{webUuid}`,
    channelId: '-1003734020722'
  },
  master130: {
    bot: `https://t.me/gameflow_platform_bot?start={code}-{webUuid}`,
    channelId: '-1003760316700'
  }
}

const tgChannelConfig = {
  dev: tgChannelConfigTest,
  test: tgChannelConfigTest,
  pre: tgChannelConfigPre,
  pro: tgChannelConfigPro
}

export const waChannelConfigTest = {
  master: 'https://wa.me/919301823128',
  bolly: 'https://wa.me/12606578743',
  gold130: 'https://wa.me/16283481971',
  master130: 'https://wa.me/16019753824'
}

export const waChannelConfigPro = {
  master: 'https://wa.me/18056781251',
  bolly: 'https://wa.me/14699363674',
  gold130: 'https://wa.me/14022752710',
  master130: 'https://wa.me/12569737027'
}

const waChannelConfig = {
  dev: waChannelConfigTest,
  test: waChannelConfigTest,
  pre: waChannelConfigTest,
  pro: waChannelConfigPro
}

export function getWaChannelConfig() {
  return waChannelConfig[env][productType]
}

export function getTgChannelConfig() {
  const code = localStorage.getItem(codeKey)
  const webUuid = localStorage.getItem(uuIdKey)
  const newUid = webUuid.split('-').join('_')
  const baseConfig = tgChannelConfig[env]
  const currentConfig = baseConfig[productType]
  return {
    ...currentConfig,
    bot: currentConfig.bot.replace('{code}', code)?.replace('{webUuid}', newUid)
  }
}

const adjustTokenMapGo = {
  pwa_web_click: { eventToken: 'apvh42' },
  pwa_newuser_Click: { eventToken: '8h7lut', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: '5vydhm',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: 'sel81p', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'v2wtyt',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: 'uxlyx5',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: 'meh1jc', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: '6fhtve' },
  'pwa_User returns': { eventToken: 'mbx0ng', deduplicationId: 'pwa_User returns' }
}

const adjustTokenMapEarn = {
  pwa_web_click: { eventToken: '28lcqf', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: '6uf9g0', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: 'aezitl',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: '2rvpx7', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'm43rmu',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: '3lgc35',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: 'y4t5at', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'c3lttn' },
  'pwa_User returns': { eventToken: 'iqf48r', deduplicationId: 'pwa_User returns' },
  screen_ads: { eventToken: 'b1lgkp', deduplicationId: 'screen_ads' },
  click_order: { eventToken: 'srku9c', deduplicationId: 'click_order' },
  page_display: { eventToken: '4987a2', deduplicationId: 'page_display' },
  click_20_button: { eventToken: 'eh3mk8', deduplicationId: 'click_20_button' },
  win_exposure: { eventToken: 'vv4u3o', deduplicationId: 'win_exposure' },
  win_click: { eventToken: 'gu3eih' },
  no_box_click: { eventToken: '60xki2' },
  Insufficient_balance: { eventToken: 'mqjc2e' },
  not_eligible_withdrawal: { eventToken: 'bcy1sh' }
}

const adjustTokenMapMakeFB = {
  pwa_web_click: { eventToken: 's0sslt', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: '1fdbgz', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: '5uaf4e',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: 't7pwic', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: '4m8tlz',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: 'd3gibh',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: '366ai9', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'hgdkky' },
  'pwa_User returns': { eventToken: '4t61c5', deduplicationId: 'pwa_User returns' }
}

const adjustTokenMapMakeWM = {
  pwa_web_click: { eventToken: 'desgmo', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: 'fuj0uj', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: '87kj0g',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: '6rnddt', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'y0o28d',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: 'nncnyz',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: 'ff09zp', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'jcy6rq' },
  'pwa_User returns': { eventToken: '3m0s8u', deduplicationId: 'pwa_User returns' }
}

const adjustTokenMapSlm130 = {
  pwa_web_click: { eventToken: 'gnqo45', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: 'rewpvg', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: 'jxiebw',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: '5cpdna', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'vf8qcw',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: '41q4jy',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: 'skoqcs', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'jjnl3j' },
  'pwa_User returns': { eventToken: 'unvo8p', deduplicationId: 'pwa_User returns' }
}
const adjustTokenMapSlg30 = {
  pwa_web_click: { eventToken: 'fbv5ix', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: '2ewmkc', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: '3u3b3v',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: 'okdjuh', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'zgwifz',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: '2lsoax',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: '6f1gae', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'xr8c94' },
  'pwa_User returns': { eventToken: 'e8ox5t', deduplicationId: 'pwa_User returns' }
}
const adjustTokenMapSlg130 = {
  pwa_web_click: { eventToken: 'krax9w', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: '58k6h5', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: 'au59mb',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: 'k1omqi', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'i7s90x',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: 'hbcdyz',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: '8azoe2', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'cffiqw' },
  'pwa_User returns': { eventToken: 'bosmr3', deduplicationId: 'pwa_User returns' }
}

const adjustTokenMapSlg30b = {
  pwa_web_click: { eventToken: 'b9mv1i', deduplicationId: 'pwa_web_click' },
  pwa_newuser_Click: { eventToken: '3xhm2x', deduplicationId: 'pwa_newuser_Click' },
  'pwa_successfully subscribed': {
    eventToken: 'll6gdn',
    deduplicationId: 'pwa_successfully subscribed'
  },
  'pwa_add Desktop': { eventToken: '2bqe05', deduplicationId: 'pwa_add Desktop' },
  pwa_unfinished_Withdraw_Click: {
    eventToken: 'x15s62',
    deduplicationId: 'pwa_unfinished_Withdraw_Click'
  },
  pwa_finished_Withdraw_Click: {
    eventToken: 'ccq1xe',
    deduplicationId: 'pwa_finished_Withdraw_Click'
  },
  pwa_register_H5: { eventToken: 'v8jjvs', deduplicationId: 'pwa_register_H5' },
  pwa_taurus_apk_download_Click: { eventToken: 'jgx3t2' },
  'pwa_User returns': { eventToken: 'ntkfp9', deduplicationId: 'pwa_User returns' }
}
const adjustTokenReferralEarn = {
  'tg-mini app_open_success': { eventToken: 'pec5mr', deduplicationId: 'tg-mini app_open_success' },
  newbie_task_complete: { eventToken: 'nawv69', deduplicationId: 'newbie_task_complete' },
  order_complete_user: { eventToken: 'm7fkwd' },
  order_complete_count: { eventToken: 'sdww9n' },
  non_tg_order_complete: { eventToken: 'yqeot2', deduplicationId: 'non_tg_order_complete' }
}

const shareFrom = getShareFrom()
const isFromFB = shareFrom.startsWith('fb')

const privateTrafficPkg = isProductApp
  ? isFromShortLink
    ? 'com.taurus.pwa.shortlink'
    : `com.taurus.pwa.PrivateTraffic.${productType}`
  : ''
const privateTrafficApp = isProductApp ? `Private traffic ${productType}` : ''
export const channelSourceMap = {
  master: 'MASTER_30',
  bolly: 'BOLLY_GAME',
  master130: 'MASTER_130',
  gold130: 'GOLD_130'
}

function getGoAppVersion() {
  if (!isProductApp) {
    return TAURUS_GO_VERSION
  }
  // 短链平台
  if (isFromShortLink || productType === 'master130') {
    return '230100'
  }
  if (productType === 'master') {
    return '228100'
  }
  if (productType === 'bolly') {
    return '229100'
  }
  if (productType === 'gold130') {
    return '240100'
  }
}

let pkgName = ''
let channelName = ''
let appName = ''
let fbdownload = ''
let adjustAppToken = ''
let adjustEventToken = {}
let appVersion = ''
const advertiseType = import.meta.env.VITE_AD
switch (appType) {
  case 'agentGrowth':
    pkgName = 'com.taurus.tg.promotersGrowth'
    channelName = 'tg.promotersGrowth'
    appName = 'AgentGrowth'
    appVersion = '100'
    adjustAppToken = 't5brkdd7kjr4'
    break
  case 'referralEarn':
    pkgName = 'com.referral.task'
    channelName = '10003a'
    appName = 'LootCash'
    appVersion = '100'
    adjustAppToken = 't5brkdd7kjr4'
    adjustEventToken = adjustTokenReferralEarn
    break
  case 'out':
    pkgName = 'com.taurus.pwa.taurus.go'
    channelName = 'pwa_giveaway'
    appName = 'Taurus GO'
    fbdownload = 'taurusGo'
    adjustAppToken = '4f8j8qmcv534'
    adjustEventToken = adjustTokenMapGo
    appVersion = TAURUS_GO_VERSION
    break
  case 'giveaway':
    pkgName = 'com.lifafa.web.mobile'
    channelName = 'lifafa_web_mobile'
    appName = 'Lifafa web mobile'
    appVersion = '100'
    adjustAppToken = '4f8j8qmcv534'
    break
  case 'go':
    pkgName = privateTrafficPkg || 'com.taurus.pwa.taurus.go'
    channelName = isProductApp
      ? isFromShortLink
        ? 'pwa_shortlink'
        : 'pwa_privatetraffic'
      : 'pwa_taurus_go'
    appName = privateTrafficApp || 'Taurus GO'
    fbdownload = 'taurusGo'
    adjustAppToken = '4f8j8qmcv534'
    adjustEventToken = adjustTokenMapGo
    appVersion = getGoAppVersion()
    break
  case 'earn':
    pkgName = 'com.taurus.pwa.online.earning'
    channelName =
      isOnlineEarning && shareFrom === 'AFFILIATE'
        ? 'affiliate_online_earning'
        : 'pwa_online_earning'
    appName = 'Online Earning'
    fbdownload = 'onlineEarning'
    adjustAppToken = '9qrrcywklqf4'
    adjustEventToken = adjustTokenMapEarn
    appVersion = ONLINE_EARNING_VERSION
    break
  case 'make':
    pkgName = 'com.taurus.pwa.make.money'
    channelName = `pwa_make_money_${isFromFB ? 'fb' : 'wm'}`
    appName = 'Make Money'
    fbdownload = 'makeMoney'
    adjustAppToken = isFromFB ? 'n6saa7x0c8hs' : '2gk95ivzyjcw'
    adjustEventToken = isFromFB ? adjustTokenMapMakeFB : adjustTokenMapMakeWM
    appVersion = MAKE_MONEY_VERSION
    if (
      window.location.href.includes('/devTransfer') ||
      window.location.href.includes('/wheeldraw') ||
      window.location.href.includes('/slot')
    ) {
      channelName = 'dev'
    }
    if (advertiseType == 'slm130') {
      pkgName = 'com.pwa.master130'
      channelName = `pwa_master_130`
      appName = 'PWA-master 130'
      fbdownload = 'makeMoneyMaster130'
      adjustAppToken = '2qf6cri4ivuo'
      adjustEventToken = adjustTokenMapSlm130
      appVersion = '231100'
    } else if (advertiseType == 'slg30') {
      pkgName = 'com.pwa.gold30'
      channelName = `pwa_gold_30`
      appName = 'PWA-gold 30'
      fbdownload = 'makeMoneyGold30'
      adjustAppToken = '9dcy4t4ilpfk'
      adjustEventToken = adjustTokenMapSlg30
      appVersion = '232100'
    } else if (advertiseType == 'slg130') {
      pkgName = 'com.pwa.gold130'
      channelName = `pwa_gold_130`
      appName = 'PWA-gold 130'
      fbdownload = 'makeMoneyGold130'
      adjustAppToken = 'vph4nlswfoxs'
      adjustEventToken = adjustTokenMapSlg130
      appVersion = '233100'
    } else if (advertiseType == 'slg30b') {
      pkgName = 'com.pwa.gold30'
      channelName = `pwa_gold_30B`
      appName = 'PWA-gold 30'
      fbdownload = 'makeMoneyGold30B'
      adjustAppToken = 'm627ukhu4y68'
      adjustEventToken = adjustTokenMapSlg30b
      appVersion = '234100'
    }
    if (isTGPlatformByBuildType()) {
      if (TG_APP_TYPE == 'spin') {
        pkgName = 'com.tg.aazmaluckaazma'
        channelName = `tg_aazmaluckaazma`
        appName = 'TG-aazmaluckaazma'
        appVersion = '300100'
      } else if (TG_APP_TYPE == 'coin') {
        pkgName = 'com.tg.coin'
        channelName = `tg_coin`
        appName = 'TG-COIN'
        appVersion = '301100'
      }
    }
    break
  case 'mmseo':
    pkgName = 'com.taurus.pwa.make.money.seo'
    channelName = 'pwa_make_money_seo'
    appName = 'Make Money'
    fbdownload = 'makeMoneySeo'
    adjustAppToken = '2gk95ivzyjcw'
    appVersion = MAKE_MONEY_SEO_VERSION
    break
  default:
    break
}

export const sPkg = `${pkgName}`
export const sChannel = `${channelName}`

export function getChannelSource() {
  if (productType) {
    return channelSourceMap[productType]
  }
  if (isReferralEarnApp) {
    return 'REFERRAL_EARN'
  }
  if (isAgentGrowthApp) {
    return 'AGENT_GROWTH'
  }
  return sChannel
}

export const defaultAvatar = 'https://static.taer.xyz/avatar/default-avatar1.webp'

export const firebaseConfig = {
  apiKey: 'AIzaSyD1fRzFAkZ7cMoAGvUhDBmIBT0cEuTcuT0',
  authDomain: 'taurus-web-app.firebaseapp.com',
  projectId: 'taurus-web-app',
  storageBucket: 'taurus-web-app.appspot.com',
  messagingSenderId: '560387821479',
  appId: '1:560387821479:web:a9c6ec8c506ba191397082',
  measurementId: 'G-Z9NL89JRJ1'
}

export const adjustTokenMap = adjustEventToken
export const adjustToken = adjustAppToken
export const taurusAppName = appName
export const version = appVersion
export const fbdownloadName = fbdownload
export const openBlindBoxToast = 'Too crowded now! Try it later'
export const coinSwitchKey = 'coin_v_switch'

export const helpCodeKey = 'h_c_key'

export const authCodeKey = 'a_c_key'

// tg的分享url前缀
export const tgShareUrl = 'https://t.me/share/url?url='

// 是否经过AB test 策略后的，本地缓存
export const abTestIsRandomkey = `a_t_i_r_k_${appType}`

const pwaUrlMap = {
  go: import.meta.env.VITE_GO_URL,
  earn: import.meta.env.VITE_EARN_URL,
  make: import.meta.env.VITE_MAKE_URL,
  mmseo: import.meta.env.VITE_MAKE_SEO_URL
}

export const homeBackUrl = pwaUrlMap[appType]

export const coinFbDownloadUrl = appType == 'go' ? 'coinTaurusGo' : 'coinOnlineEarning'

export const SHARE_MEDIA_MAP = {
  WhatsApp: 'com.whatsapp',
  Telegram: 'org.telegram.messenger',
  Facebook: 'com.facebook.katana',
  Instagram: 'com.instagram.android',
  YouTube: 'com.google.android.youtube',
  More: 'more'
}

export const luckyDrawMiniAppLink = {
  dev: 'https://t.me/LuckyDrawTestEnv_bot/LuckyDrawTest',
  test: 'https://t.me/LuckyDrawTestEnv_bot/LuckyDrawTest',
  pre: 'https://t.me/luckydrawpreenv_bot/luckydrawpreenv',
  pro: 'https://t.me/aazmaluckaazma_bot/aazmaluckaazma'
}

export const deviceInfoMap = {
  Android: 'android',
  iOS: 'ios',
  Windows: 'windows',
  'Mac OS': 'mac'
}

export const isDev = env == 'dev'

export const realPkgTypeKey = 'pkgT'

export const giveawayWithdrawedKey = 'g_w_k'

export const giveawayPcodeKey = 'g_p_c_k'

export const validVideoTypes = [
  'video/mp4',
  'video/avi',
  'video/quicktime',
  'video/x-ms-wmv',
  'video/x-flv',
  'video/webm',
  'video/x-matroska'
]

export const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png']

// 直接跳到任务详情的缓存key
export const redirectTaskDetailKey = 'r_task_d_k'

export const uplodFileStatus = [503, 502, 500]

// agentGrowTh 是否点击过follow 按钮
export const clickFollowedTgBtnKey = 'c_f_t_b_k'

// agentGrowth判断是否需要校验tg
export const checkTgChannelKey = 'a_g_c_t_c_key'

// referralEarn 任务列表api缓存key
export const taskListCacheKey = 'referralEarn_task_list_api_key'

// taskJoy 任务列表缓存key
export const taskJoyListCacheKey = 'taskjoy_task_list_api_key'

// 提现排队任务
export const withdrawTaskConfig = [
  {
    type: 'REFERRAL_EARN_WITHDRAW_INVITE_TASK',
    cacheKey: 'w_invite_t',
    taskType: 'INVITE',
    shouldShow: (currentNum) => currentNum <= 3
  },
  {
    type: 'REFERRAL_EARN_WITHDRAW_WA_RECALL_TASK',
    cacheKey: 'w_wa_t',
    taskType: 'WA_RECALL'
  },
  {
    type: 'REFERRAL_EARN_WITHDRAW_INSTALL_TAURUS',
    cacheKey: 'w_install_t',
    taskType: 'INSTALL_TAURUS'
  }
]

/**
 * cpl 累积的额外奖励的key
 */
export const contactCplRewradKey = 'c_c_r_key'

/**
 * 是否触发过挽留到大转盘
 */
export const hasRetainSpinKey = 'h_r_spin_key'
